<template>
	<div class="flex flex-col lg:h-full">
		<div class="flex flex-grow relative">
			<div class="w-full mr-12 lg:mr-0 main">
				<div v-if="manufacturerUnchecked" class="mb-8">
					<div class="text-lg mb-4 font-bold text-left">{{ $t('new_manufacturers') }}</div>
					<VehicleManufacturerForm
						:manufacturers="manufacturerUnchecked"
						@delete="deleteManufacturer"
						@save="saveManufacturer"
						:is-manufacturer-type-all="false"
					/>
				</div>

				<div class="mr-12 pr-4 ml-4">
					<BaseInput :label="$t('search')" @input="search($event)" :filter-only="true" :sublabel="$t('min_two_chars')" v-model="searchValue" />
					<div v-if="manufacturer">
						<BaseTable
							:heads="heads"
							:rows="manufacturer"
							v-if="manufacturer.length"
							:mapping="mapping"
							:enable-search="false"
							:row-main-function="editManufacturer"
						/>
						<div v-else>
							{{ $t('no_manufacturer_found') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import { VehiclesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import VehicleManufacturerForm from '@/views/vehicles/VehicleManufacturerForm';
import LoadingSpinner from '@/mixins/LoadingSpinner';
import BaseTable from '@/components/forms/BaseTable';
import VehicleManufacturerRepository from '@/api/repositories/VehicleManufacturerRepository';

export default {
	name: 'VehiclesManufacturer',
	components: { BaseTable, VehicleManufacturerForm, BaseInput },
	mixins: [LoadingSpinner],
	data() {
		return {
			searchValue: null,
			searchTimeoutId: null,
			manufacturer: null,
			manufacturerUnchecked: null,
			heads: [
				{ title: this.$t('wmi'), key: 'wmi' },
				{ title: this.$t('name'), key: 'name' },
			],
		};
	},
	mounted() {
		VehicleManufacturerRepository.getUncheckedManufacturerList().then(response => {
			this.manufacturerUnchecked = response.data.data;
		});
		if (this.$route.query.searchValue) {
			this.searchValue = this.$route.query.searchValue;
			this.search();
		}
	},
	methods: {
		search() {
			clearTimeout(this.searchTimeoutId);
			this.searchTimeoutId = setTimeout(() => {
				if (this.searchValue.length > 1) {
					this.loadManufacturer();
				} else {
					this.manufacturer = null;
					this.$router.replace({ name: this.$route.name, query: { searchValue: this.searchValue } });
				}
			}, 300);
		},
		mapping(row) {
			return {
				id: row['id'],
				wmi: row['wmi'],
				name: row['name'],
			};
		},
		editManufacturer(row) {
			this.$router.push({ name: 'vehicles.manufacturer.id', params: { id: row.id } });
		},
		loadManufacturer() {
			return VehicleManufacturerRepository.index({ searchValue: this.searchValue }).then(response => {
				this.manufacturer = response.data.data;
				this.$router.replace({ name: this.$route.name, query: { searchValue: this.searchValue } });
			});
		},
		saveManufacturer(manufacturer) {
			this.setLoadingStatus(true);
			return VehiclesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.vehiclesManufacturerPut(manufacturer)
				.then(response => {
					this.$store.commit('setConfirmLeaving', false);
					this.$swal(this.$t('general.success').toString(), this.$t('copied_selected_to_total').toString(), 'success');
					this.setLoadingStatus(false);
					this.$router.push({ name: 'vehicles.overview' });
				});
		},
		deleteManufacturer(manufacturerId) {
			VehiclesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.vehiclesManufacturerIdDelete(manufacturerId)
				.then(response => {
					this.$store.commit('setConfirmLeaving', false);
					this.$swal(this.$t('general.success').toString(), this.$t('manufacturer_deleted_successfully').toString(), 'success');
				});
		},
	},
};
</script>

<style scoped>
.main {
	height: 100vh; /*limit durch max-height*/
}
</style>
